/**
 *
 * AmbulanceTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { MedicalServiceIcon } from 'assets/v2/icons';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.orchidDark};
    background: ${COLORS.orchidLight};
    border-color: ${COLORS.orchid};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.orchid};
    }
  }
`;

function AmbulanceTag(props) {
  return (
    <StyledTag label="Ambulance" icon={<MedicalServiceIcon />} {...props} />
  );
}

export default memo(AmbulanceTag);
